import { Multiples, Submultiples } from "../../SIprefixe";
import { Unit, UnitBaseTypes } from "../../Units";

function KiloNewtonMillimetre() {
  return (
    <>
      <Unit unit={UnitBaseTypes.newton} prefix={Multiples.kilo} />
      <Unit unit={UnitBaseTypes.metre} prefix={Submultiples.milli} />
    </>
  );
}

export default KiloNewtonMillimetre;
